import axiosInstance from './AxiosInstance';

export async function getFloatDashboard({ force = false } = {}) {
    return axiosInstance.get('admin/float-dashboard', {
        params: force ? { force: 1 } : {},
    });
}

export async function getFloatReservations(page = 1) {
    return axiosInstance.get('admin/float-reservations', { params: { page } });
}

export async function getFloatReservation(reservationId) {
    return axiosInstance.get(`admin/float-reservations/${reservationId}`);
}

export async function recheckSafaricomBalance() {
    return axiosInstance.post('admin/float/recheck-safaricom');
}
